import FileSaver from "file-saver";
import json2xls from "json2xls";

export const downloadfile = (data, filename) => {
  FileSaver.saveAs(data, filename);
};
export const genexcel = jsondata => {
  return json2xls(jsondata);
};
export const genexceldownload = (filename, data, headertitles) => {
  var headers = headertitles;
  if (!headertitles) {
    headers = Object.keys(data[0]);
  }
  let downloaddata = ["\n", headers];
  for (let row of data) {
    let rowdata = ["\n"];
    Object.entries(row).map(entry => {
      rowdata = rowdata.concat(entry[1]);
    });

    downloaddata = downloaddata.concat(rowdata);
  }
  let file = new Blob([downloaddata], {
    type: "application/vnd.ms-excel"
  });
  FileSaver.saveAs(file, filename + ".csv");
};


// WEBPACK FOOTER //
// ./src/services/fileanddownloads.js